import React from 'react';
import { Box, Text } from 'core/components';

const FpsAlert = ({ type, avgConfiguredSamplingRate, dataResolution }) => {
  let shouldShow = false;
  let backgroundColor;
  let message;
  const msgCopy = 'high for your current plan. Please contact your account team.';

  if (type === 'raw' && avgConfiguredSamplingRate && avgConfiguredSamplingRate !== 'N/A') {
    // Parse the sampling rate (e.g., "1:2.5" -> 2.5)
    const parseSamplingRate = (rateString) => {
      const match = rateString.match(/^1:(\d+(?:\.\d+)?)$/);
      return match ? parseFloat(match[1]) : null;
    };

    const samplingRatio = parseSamplingRate(avgConfiguredSamplingRate);

    // Show alert if sampling rate is more than 1:1
    if (samplingRatio && samplingRatio > 1) {
      shouldShow = true;
      if (samplingRatio > 2) {
        // More than 1:2 - red/pink alert
        backgroundColor = 'rgba(255, 138, 128, 0.3)';
        message = `Raw FPS is very ${msgCopy}`;
      } else {
        // More than 1:1 up to 1:2 - yellow alert
        backgroundColor = 'rgba(255, 235, 59, 0.3)';
        message = `Raw FPS is ${msgCopy}`;
      }
    }
  } else if (type === 'received' && dataResolution && dataResolution !== 'ok') {
    shouldShow = true;
    if (dataResolution === 'low') {
      // Red/pink alert for low resolution
      backgroundColor = 'rgba(255, 138, 128, 0.3)';
      message = `Received FPS is very ${msgCopy}`;
    } else if (dataResolution === 'downsampled') {
      // Yellow alert for downsampled
      backgroundColor = 'rgba(255, 235, 59, 0.3)';
      message = `Received FPS is ${msgCopy}`;
    }
  }

  if (!shouldShow || !message) {
    return null;
  }

  return (
    <Box mt={2} p={2} style={{ backgroundColor }} borderRadius="3px" border="1px solid rgba(0,0,0,0.1)">
      <Text fontSize="small" color="#333">
        ⚠ {message}
      </Text>
    </Box>
  );
};

export default FpsAlert;
